import script from "./Tab.vue?vue&type=script&setup=true&lang=js"
export * from "./Tab.vue?vue&type=script&setup=true&lang=js"

import "./Tab.vue?vue&type=style&index=0&id=5b7bba64&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b7bba64"]])

export default __exports__